(function () {
  'use strict';

  function init(root) {
    if (root.dataset.brandsInit === '1') return;
    root.dataset.brandsInit = '1';

    var track = root.querySelector('[data-brands-track]');
    var prev = root.querySelector('[data-brands-prev]');
    var next = root.querySelector('[data-brands-next]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflow = max > 2;
      if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
      if (next) next.hidden = !overflow || track.scrollLeft >= max;
    }

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    window.addEventListener('load', update);
    setTimeout(update, 400);
  }

  function initAll() {
    document.querySelectorAll('[data-brands]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-brands]');
    if (el) init(el);
  });
})();
